import { render } from "./ProjectDetail.vue?vue&type=template&id=0dcb2ce6&scoped=true&ts=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=ts"
export * from "./ProjectDetail.vue?vue&type=script&lang=ts"

import "./ProjectDetail.vue?vue&type=style&index=0&id=0dcb2ce6&lang=scss&scoped=true"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcb2ce6"]])

export default __exports__